"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FooterRow;

var React = _interopRequireWildcard(require("react"));

function FooterRow(props) {
  return React.createElement("tr", Object.assign({}, props));
}